import styles from './ProjectDocuments.module.scss';
import classnames from 'classnames';
import { isMobile } from 'react-device-detect';

const ProjectDocuments = ({ props }) => {
  return (
    <section className={classnames(isMobile ? [styles.section, styles.mobile] : [styles.section])}>
      <h2 className={classnames(isMobile ? [styles.sectionTitle, styles.mobile] : [styles.sectionTitle])}>Документы</h2>

      <ul className={classnames(isMobile ? [styles.list, styles.mobile] : [styles.list])}>
        {props.map((doc) => (
          <li className={classnames(isMobile ? [styles.item, styles.mobile] : [styles.item])} key={doc.id}>
            <a href={doc.document} target="_blank" rel="noreferrer">
              {doc.title}
            </a>
          </li>
        ))}
      </ul>
    </section>
  );
};

export default ProjectDocuments;
